type UnauthorizedHandler = () => void | Promise<void>;

let unauthorizedHandler: UnauthorizedHandler | null = null;
let handlingUnauthorized = false;
let lastHandledAt = 0;

/** Prevents repeated logout/navigation when several API calls fail with 401 in a row. */
const UNAUTHORIZED_COOLDOWN_MS = 2_000;

export function setLinkoUnauthorizedHandler(
  handler: UnauthorizedHandler | null,
): void {
  unauthorizedHandler = handler;
}

function isLogoutRequest(url: string): boolean {
  return /logout/i.test(url);
}

function isSessionProbeRequest(url: string): boolean {
  return /getLoggedInUser/i.test(url);
}

export async function notifyLinkoUnauthorized(
  requestUrl?: string,
): Promise<void> {
  const url = requestUrl ?? "";
  if (isLogoutRequest(url) || isSessionProbeRequest(url)) return;
  if (!unauthorizedHandler || handlingUnauthorized) return;

  const now = Date.now();
  if (now - lastHandledAt < UNAUTHORIZED_COOLDOWN_MS) return;

  handlingUnauthorized = true;
  try {
    await unauthorizedHandler();
    lastHandledAt = Date.now();
  } finally {
    handlingUnauthorized = false;
  }
}

/** @internal test helper */
export function resetLinkoUnauthorizedStateForTests(): void {
  unauthorizedHandler = null;
  handlingUnauthorized = false;
  lastHandledAt = 0;
}
